module.exports = __webpack_public_path__ + "static/media/rubii.520105f6.png";